import { render, staticRenderFns } from "./HeaderDots.vue?vue&type=template&id=62b08f08"
import script from "./HeaderDots.vue?vue&type=script&lang=js"
export * from "./HeaderDots.vue?vue&type=script&lang=js"
import style0 from "./HeaderDots.vue?vue&type=style&index=0&id=62b08f08&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b08f08')) {
      api.createRecord('62b08f08', component.options)
    } else {
      api.reload('62b08f08', component.options)
    }
    module.hot.accept("./HeaderDots.vue?vue&type=template&id=62b08f08", function () {
      api.rerender('62b08f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Components/Header/HeaderDots.vue"
export default component.exports